import React from 'react';
import styled from 'styled-components';
import {Grid} from '@material-ui/core';
import {AccentColorOptions} from 'epic-ue-theme';
import {Button, TextLink, Typography, VerticalSpacer} from '../..';
import {TextLinkUnderlineWrap} from '../../links/TextLinkUnderlineWrap';

const Styled = styled.div`
    && {
        svg {
            font-size: 1.8rem;
            margin-left: -${(p) => p.theme.spacing(0.5)}px;
        }
        .bottom-links {
            padding-left: 12px;

            a.ue-link-wrap {
                text-decoration: underline;
                text-underline-position: under;
            }
        }
        .caption span {
            vertical-align: text-bottom;
        }
    }
`;

const HyperlinkSeperator = styled.div`
    padding-right: 15px;
    padding-left: 15px;
`;

export interface LicenseLinkProps {
    label?: string;
    href?: string;
}
export interface LicenseLinksCaptionProps {
    className?: string;
    accentColor?: AccentColorOptions;
    links?: LicenseLinkProps[];
    caption?: string;
    buttonHref?: string;
    buttonText?: string;
}

export const LicenseLinksCaption = ({
    className,
    accentColor = 'sky',
    links,
    caption,
    buttonHref,
    buttonText
}: LicenseLinksCaptionProps): JSX.Element => {
    return (
        <Styled className={`${className || ''} License-links-caption`}>
            {links && (
                <>
                    {' '}
                    <Grid className="bottom-links" container direction="row" spacing={3}>
                        {links?.map((link, i) => {
                            return (
                                <React.Fragment key={`${link.label}-${i}`}>
                                    {' '}
                                    {i > 0 && <HyperlinkSeperator>|</HyperlinkSeperator>}{' '}
                                    <TextLinkUnderlineWrap textColor="black">
                                        <TextLink href={link.href}>{link.label}</TextLink>{' '}
                                    </TextLinkUnderlineWrap>
                                </React.Fragment>
                            );
                        })}
                    </Grid>
                </>
            )}
            {caption && (
                <>
                    <VerticalSpacer variant="heading" />
                    <Typography variant="p" caption accentColor={accentColor}>
                        {caption}
                    </Typography>
                </>
            )}
            {buttonHref && (
                <>
                    <VerticalSpacer variant="custom" spacing={7} downSmSpacing={5} />
                    <Button href={buttonHref}>{buttonText}</Button>
                    <VerticalSpacer variant="custom" spacing={7} downSmSpacing={5} />
                </>
            )}
        </Styled>
    );
};
